import React, { useState, useEffect, useRef } from "react";
import styles from "./Carousel.module.scss";

const Carousel = ({ children, interval = 3000, infiniteRotate = true, barActiveColor = "#333", barInactiveColor = "#ccc", onSlideChange, dynamicBackground ,hideFocusToIndicatorAndListBehavior = false}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const totalSlides = React.Children.count(children);
  const startX = useRef(0);
  const moveX = useRef(0);
  const autoSlideRef = useRef(null);

  useEffect(() => {
    if (onSlideChange) onSlideChange(currentIndex);
  }, [currentIndex]);
  
  // Auto-slide logic
  useEffect(() => {
    if (isDragging || totalSlides <= 1 || interval <= 0) return;
  
    autoSlideRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, interval);
  
    return () => clearInterval(autoSlideRef.current);
  }, [currentIndex, interval, isDragging, totalSlides]);  

  // Touch handlers for mobile swiping
  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
    setIsDragging(true);
    clearInterval(autoSlideRef.current);
  };

  const handleTouchMove = (e) => {
    moveX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
    const deltaX = startX.current - moveX.current;

    if (deltaX > 50) {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    } else if (deltaX < -50) {
      setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
    }
  };

  return (
    <div className={'carouselContainer'} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} style={{ background: dynamicBackground}}>
      <div
        className={'carouselWrapper'}
        style={{
          display: "flex", // FIX: Ensure slides align properly
          width: `${totalSlides * 100}%`, // FIX: Ensure all slides fit inside
          transform: `translateX(-${currentIndex * (100 / totalSlides)}%)`,
          transition: isDragging ? "none" : "transform 0.4s ease-out"
        }}
        role={hideFocusToIndicatorAndListBehavior ? "list" : undefined}
      >
        {React.Children.map(children, (child, index) => (
          <div key={index} className={'slideBottomStrip'} style={{ width: `${100 / totalSlides}%` }} role={hideFocusToIndicatorAndListBehavior ? "listitem" : undefined}>
            {child}
          </div>
        ))}
      </div>

      {/* Progress Bars */}
      {totalSlides > 1 && (
        <div className={'progressBarContainer'} aria-hidden={hideFocusToIndicatorAndListBehavior}>
          {Array.from({ length: totalSlides }).map((_, index) => (
            <div
              key={index}
              className={`progressBar ${index === currentIndex ? 'active' : ""}`}
              style={{
                backgroundColor: index === currentIndex ? barActiveColor : barInactiveColor,
                width: index === currentIndex ? "30px" : "20px", // Active bar wider
                height: "3px",
              }}
              onClick={() => {
                setCurrentIndex(index);
                if (onSlideChange) onSlideChange(index);
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Carousel;